import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../config';
import { LeoSubscriptionsResponse } from '../../types/subscriptions';
import deviceInfoAxios from '../../utils/axios/deviceInfo.axios';

const tryToFetchLeoSubscriptions = (): Promise<
    AxiosResponse<LeoSubscriptionsResponse>
> => {
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/leo/subscriptions`);
};

export const SubscriptionsService = {
    tryToFetchLeoSubscriptions,
};
